import React, { useState, useEffect } from 'react';
import { Input } from 'antd';
import { formatCurrency } from '../../utils/formatCurrency';

const FormattedCurrencyInput = ({ value, onChange, ...props }) => {
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    if (value) {
      setDisplayValue(formatCurrency(parseFloat(value)));
    } else {
      setDisplayValue('');
    }
  }, [value]);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const rawValue = inputValue.replace(/,/g, '');
    
    if (onChange) {
      onChange(rawValue);
    }
  };

  const handleBlur = (e) => {
    const rawValue = e.target.value.replace(/,/g, '');
    if (rawValue) {
      setDisplayValue(formatCurrency(parseFloat(rawValue)));
    }
  };

  return (
    <Input
      {...props}
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder="00.00"
      prefix="$"
    />
  );
};

export default FormattedCurrencyInput;
